export const MEDIA_UPLOAD_STAGES = {
    PREPARING: 'preparing',
    UPLOADING: 'uploading',
    PROCESSING: 'processing',
    DELETING: 'deleting',
};

export const MEDIA_UPLOAD_STAGE_LABELS = {
    [MEDIA_UPLOAD_STAGES.PREPARING]: 'Preparing image…',
    [MEDIA_UPLOAD_STAGES.UPLOADING]: 'Uploading…',
    [MEDIA_UPLOAD_STAGES.PROCESSING]: 'Creating sizes…',
    [MEDIA_UPLOAD_STAGES.DELETING]: 'Removing image…',
};

export const computeMediaUploadProgress = (stage, byteProgress = 0) => {
    if (stage === MEDIA_UPLOAD_STAGES.PREPARING) {
        return 12;
    }
    if (stage === MEDIA_UPLOAD_STAGES.UPLOADING) {
        return 15 + Math.round(byteProgress * 0.55);
    }
    if (stage === MEDIA_UPLOAD_STAGES.PROCESSING) {
        return 85;
    }
    if (stage === MEDIA_UPLOAD_STAGES.DELETING) {
        return 60;
    }
    return 0;
};
